module.exports = __webpack_public_path__ + "static/media/a-1.1s-128px.aee92ec2.svg";